// extracted by mini-css-extract-plugin
export default {"not-found-container":"NotFound_not-found-container__UuSej","modal":"NotFound_modal__8hE59","inner-container":"NotFound_inner-container__5CYFX"};